import { createSlice } from "@reduxjs/toolkit";
import { initPictureEditObj } from "../data/type";

//Sliceの作成
export const pictureEditSlice = createSlice({
    name: "picture",
    initialState: initPictureEditObj,

    //toolKitを利用した値変更処理
    reducers: {
        setPictureEditMode: (state, action) => {
            state.editMode = action.payload;
        },
        setPictureReload: (state, action) => {
            state.reload = action.payload;
        },
        setPictureCropRect: (state, action) => {
            state.cropRect = action.payload;
        },
        setPictureOriginCropRect: (state, action) => {
            state.originCropRect = action.payload;
        },
    },
});

export const {
    setPictureEditMode,
    setPictureReload,
    setPictureCropRect,
    setPictureOriginCropRect,
} = pictureEditSlice.actions;
export default pictureEditSlice.reducer;
